import { render } from "./ControlCategoryModal.vue?vue&type=template&id=568bae12&scoped=true"
import script from "./ControlCategoryModal.vue?vue&type=script&lang=js"
export * from "./ControlCategoryModal.vue?vue&type=script&lang=js"

import "./ControlCategoryModal.vue?vue&type=style&index=0&id=568bae12&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568bae12"]])

export default __exports__